export var useStructuredData = function(products, page) {
    if (!page || !("content" in page) || !("article" in page.content)) return {
        faqs: undefined
    };
    var faqs = page.content.article.segments.filter(function(segment) {
        return segment.moduleType === "faqs";
    }).flatMap(function(segment) {
        return segment.content;
    });
    var ref;
    return {
        faqs: faqs,
        name: (ref = products === null || products === void 0 ? void 0 : products.name) !== null && ref !== void 0 ? ref : ""
    };
};
